import * as React from "react";

import { useDomainServices } from "@/providers/DomainServices";
import { RobotoSwitch, RobotoTooltip } from "@/shared/components";

interface TokenSwitchProps {
  enabled: boolean;
  tokenId: string;
  setErrorText: (arg: string) => void;
}

export const TokenSwitch: React.FC<TokenSwitchProps> = ({
  enabled,
  tokenId,
  setErrorText,
}) => {
  const { tokens } = useDomainServices();

  const [switchState, setSwitchState] = React.useState<boolean>(enabled);

  const updateToken = () => {
    setErrorText("");
    if (switchState === true) {
      tokens
        .disableToken(tokenId)
        .then(() => {
          setSwitchState(!switchState);
        })
        .catch((err: unknown) => {
          const error =
            err instanceof Error
              ? err
              : new Error("Failed to disable token", {
                  cause: err,
                });
          setErrorText(error.message);
        });
    } else {
      tokens
        .enableToken(tokenId)
        .then(() => {
          setSwitchState(!switchState);
        })
        .catch((err: unknown) => {
          const error =
            err instanceof Error
              ? err
              : new Error("Failed to enable token", {
                  cause: err,
                });
          setErrorText(error.message);
        });
    }
  };

  const handleToggle = () => {
    void updateToken();
  };

  return (
    <RobotoTooltip title={switchState ? "Disable Token" : "Enable Token"}>
      <RobotoSwitch
        checked={switchState}
        onChange={handleToggle}
        inputProps={{ "aria-label": "token toggle" }}
        color="success"
      />
    </RobotoTooltip>
  );
};
